import { useContext } from 'react';

import { FeatureFlags } from './FeatureFlags.types';
import { FeatureFlagsContext } from './FeatureFlagsContext';

export const useFeatureFlags: () => Partial<FeatureFlags> = () => useContext(FeatureFlagsContext);
